var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C13 0.46875 13.4375 0 14 0C14.5312 0 15 0.46875 15 1V11C15 11.5625 14.5312 12 14 12C13.4375 12 13 11.5625 13 11V1ZM1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125L5.28125 1.3125C5.65625 0.90625 6.3125 0.90625 6.6875 1.3125C7.09375 1.6875 7.09375 2.34375 6.6875 2.71875L4.40625 5H10C10.5312 5 11 5.46875 11 6C11 6.5625 10.5312 7 10 7H4.40625L6.6875 9.3125C7.09375 9.6875 7.09375 10.3438 6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875Z",
    fill: "#3C3C43",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.007276b6.svg";
export { ForwardRef as ReactComponent };